import './FeedbackArticle.scss';

interface FeedbackArticleProps {
  url: string | null;
  label: string | null;
}

const FeedbackArticle = ({ url, label }: FeedbackArticleProps) => {
  if (label === null || label === '') {
    return null;
  }
  return (
    <div className="feedbackArticle">
      <a href={url} className="appButton" target="_blank" rel="noreferrer">
        {label}
      </a>
    </div>
  );
};

export default FeedbackArticle;
